import type { WorkoutType } from '../services/api';
import { normalizeLocale } from '../i18n/config';

/** Pick localized sport name from API/static workout type row. */
export function workoutTypeLabel(item: WorkoutType, locale?: string): string {
  const lng = normalizeLocale(locale);
  const faName = (item.name ?? '').trim();
  const enName = (item.english_name ?? '').trim();
  // Treat empty string as missing — `??` alone keeps `english_name: ''` and blanks EN UI.
  if ((lng === 'fa' || lng === 'ar') && faName) return faName;
  return enName || faName;
}
